class ImageRotator {
  constructor(rotatorElement) {
    this.rotatorElement = rotatorElement;
    this.images = this.rotatorElement.querySelectorAll('figure');
    this.timePerSlide = this.rotatorElement.getAttribute('data-time-per-slide') || 5; // Default to 5 seconds
    this.currentIndex = 0;
    this.interval = null;
    this.init();  
  }

  init() {
    this.showImage(this.currentIndex);
    this.startRotation();
  }

  showImage(index) {
    this.images.forEach((img, i) => {
      img.classList.toggle('active', i === index);
    });
  }

  startRotation() {
    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.showImage(this.currentIndex);
    }, this.timePerSlide * 1000); // Change image every X seconds
  }

  reset() {
    this.currentIndex = 0;
    if(this.interval){
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

export const InitImageRotator = () => {
  const rotators = document.querySelectorAll('.image_rotator');
  rotators.forEach((rotator) => {
    rotator.rotatorInstance = new ImageRotator(rotator);
  });
}

export const InitImageRotatorEditor = () => {
  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=image-rotator', ( $block ) => {
      const rotator = $block[0].querySelector('.image_rotator');
      if(!!rotator){
        if(rotator.rotatorInstance){
          rotator.rotatorInstance.reset();
        }
        rotator.rotatorInstance = new ImageRotator(rotator);
      }
    });
  }
}